import "./productList.css";
import React, {useEffect} from "react";
import Header from "../../../components/Header/Header";
import {useNavigate} from "react-router-dom";
import Users from "../../../components/AdminCom/Users";
import PostUsers from "../../../components/AdminCom/PostUsers";

export default function ProductList() {
    const navigate = useNavigate()

    useEffect(() => {
        if (!localStorage.getItem("tokenAdmin")) {
            navigate("/adminpassword")
        }
    }, [])
    return (
        <div className="admin__main">z
            <Header/>
            <div className="mt">
                <PostUsers/>
                <Users/>
            </div>

        </div>
    );
}
